/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    MyDbProductDetails,
    instanceOfMyDbProductDetails,
    MyDbProductDetailsFromJSON,
    MyDbProductDetailsFromJSONTyped,
    MyDbProductDetailsToJSON,
} from './MyDbProductDetails';

/**
 * @type TenantProductDetails
 * tenant-specific details for products
 * @export
 */
export type TenantProductDetails = { tenant: 'MY_DB' } & MyDbProductDetails;

export function TenantProductDetailsFromJSON(json: any): TenantProductDetails {
    return TenantProductDetailsFromJSONTyped(json, false);
}

export function TenantProductDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantProductDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['tenant']) {
        case 'MY_DB':
            return {...MyDbProductDetailsFromJSONTyped(json, true), tenant: 'MY_DB'};
        default:
            throw new Error(`No variant of TenantProductDetails exists with 'tenant=${json['tenant']}'`);
    }
}

export function TenantProductDetailsToJSON(value?: TenantProductDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['tenant']) {
        case 'MY_DB':
            return MyDbProductDetailsToJSON(value);
        default:
            throw new Error(`No variant of TenantProductDetails exists with 'tenant=${value['tenant']}'`);
    }

}

